import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const createHealthScreeningPackage = createAsyncThunk(
    "healthScreeningPackage/createHealthScreeningPackage",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/healthScreeningPackage/createHealthScreeningPackage", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const updateHealthScreeningPackage = createAsyncThunk(
    "healthScreeningPackage/updateHealthScreeningPackage",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put("/healthScreeningPackage/updateHealthScreeningPackage", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const deleteHealthScreeningPackage = createAsyncThunk(
    "healthScreeningPackage/deleteHealthScreeningPackage",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.put("/healthScreeningPackage/deleteHealthScreeningPackage", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getHealthScreeningPackage = createAsyncThunk(
    "healthScreeningPackage/getHealthScreeningPackage",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/healthScreeningPackage/getHealthScreeningPackage", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

export const getHealthScreeningPackageById = createAsyncThunk(
    "healthScreeningPackage/getHealthScreeningPackageById",
    async (data, { rejectWithValue }) => {
        try {
            const response = await axios.post("/healthScreeningPackage/getHealthScreeningPackageById", data, {
                headers: {
                    "Content-Type": "application/json",
                    token: data.token
                }
            });
            return response.data
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || error.message)
        }
    }
);

const initialState = {
    loading: false,
    healthScreeningPackages: [],
    healthScreeningPackagesById: [],
    createHealthScreeningSuccessMessage: null,
    createHealthScreeningErrorMessage: null,
    updateHealthScreeningSuccessMessage: null,
    updateHealthScreeningErrorMessage: null,
    deleteHealthScreeningSuccessMessage: null,
    deleteHealthScreeningErrorMessage: null,
    totalCount: 0,
    totalPages: 1,
    currentPage: 1,
    hasMore: false
}
const healthScreeningPackageSlice = createSlice({
    name: "healthScreeningPackage",
    initialState,
    reducers: {
        resetUpdateHealthScreeningMessage: (state) => {
            state.updateHealthScreeningSuccessMessage = null;
            state.updateHealthScreeningErrorMessage = null;
        },
        resetDeleteHealthScreeningMessage: (state) => {
            state.deleteHealthScreeningSuccessMessage = null;
            state.deleteHealthScreeningErrorMessage = null;
        },
        resetCreateHealthScreeningMessage: (state) => {
            state.createHealthScreeningSuccessMessage = null;
            state.createHealthScreeningErrorMessage = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(createHealthScreeningPackage.pending, (state) => {
                state.loading = true;
            })
            .addCase(createHealthScreeningPackage.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.createHealthScreeningErrorMessage = action.payload.result.message;
                } else {
                    state.createHealthScreeningSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(createHealthScreeningPackage.rejected, (state, action) => {
                state.loading = false;
                state.createHealthScreeningErrorMessage = action.payload.result.message;
            })
            .addCase(updateHealthScreeningPackage.pending, (state) => {
                state.loading = true;
            })
            .addCase(updateHealthScreeningPackage.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.updateHealthScreeningErrorMessage = action.payload.result.message;
                } else {
                    state.updateHealthScreeningSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(updateHealthScreeningPackage.rejected, (state, action) => {
                state.loading = false;
                state.updateHealthScreeningErrorMessage = action.payload.result.message;
            })
            .addCase(deleteHealthScreeningPackage.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteHealthScreeningPackage.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.deleteHealthScreeningErrorMessage = action.payload.result.message;
                } else {
                    state.deleteHealthScreeningSuccessMessage = action.payload.result.message;
                }
            })
            .addCase(deleteHealthScreeningPackage.rejected, (state, action) => {
                state.loading = false;
                state.deleteHealthScreeningErrorMessage = action.payload.result.message;
            })
            .addCase(getHealthScreeningPackage.pending, (state) => {
                state.loading = true;
            })
            .addCase(getHealthScreeningPackage.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload.success === false) {
                    state.searchMessage = action.payload.result.message;
                    state.healthScreeningPackages = [];
                } else {
                    state.searchMessage = null;
                    state.healthScreeningPackages = action.payload.result.list;
                    state.totalCount = action.payload.result.totalRecords || 0;
                    state.totalPages = action.payload.result.totalPages || 1;
                    state.currentPage = action.payload.result.currentPage || 1;
                    state.hasMore = action.payload.result.hasMore || false;
                }
            })
            .addCase(getHealthScreeningPackage.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(getHealthScreeningPackageById.pending, (state) => {
                state.loading = true;
            })
            .addCase(getHealthScreeningPackageById.fulfilled, (state, action) => {
                state.loading = false;
                state.healthScreeningPackagesById = action.payload.result.list;
            })
            .addCase(getHealthScreeningPackageById.rejected, (state, action) => {
                state.loading = false;
            })
    }
});

export const {
    resetCreateHealthScreeningMessage,
    resetUpdateHealthScreeningMessage,
    resetDeleteHealthScreeningMessage
} = healthScreeningPackageSlice.actions;

export default healthScreeningPackageSlice.reducer;